<template>
	<div class="coll">
		<h2 class="title"><span>{{title}}</span></h2>
		<div class="cons">
			<table class="tab_detail">
				<tr>
					<th>调整编号</th><td>{{sdata.materialVoucherCode}}</td>
					<th>创建日期</th><td>{{sdata.createDate}}</td>
				</tr>
				<tr>
					<th>凭证日期</th><td>{{sdata.voucherDate}}</td>
					<th>过账日期</th><td>{{sdata.postingDate}}</td>
				</tr>
				<tr>
					<th>工厂</th><td>{{sdata.factoryCode}} {{sdata.factoryDesc}}</td>
					<th>库存地点</th><td>{{sdata.inventoryCode}}{{sdata.inventoryDesc}}</td>
				</tr>
				<tr>
					<th>备注</th><td colspan="3">{{sdata.voucherHeaderTxt}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
export default{
	props:{
		title:String,
		sdata:Object
	},
	created(){

	}
}
</script>

<style>
</style>
